import { combineReducers } from 'redux';
import {
  FETCH_ZONE_TEMPLATES,
  FETCH_ZONE_TEMPLATES_SUCCESS,
} from '../actions/zoneTemplatesRef';

const all = (state = [], action) => {
  switch (action.type) {
    case FETCH_ZONE_TEMPLATES:
      return state;
    case FETCH_ZONE_TEMPLATES_SUCCESS:
      return [...state, action.zone_templates];
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case FETCH_ZONE_TEMPLATES:
      return true;
    case FETCH_ZONE_TEMPLATES_SUCCESS:
      return false;
    default:
      return state;
  }
};

const zoneTemplatesRef = combineReducers({
  all,
  isFetching,
});

export default zoneTemplatesRef;

export const getIsFetching = state => state.manips.zoneTemplatesRef.isFetching;

export const getZoneTemplatesRef = state =>
  state.manips.zoneTemplatesRef.all[0];



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/reducers/zoneTemplatesRef.js